import { FC } from 'react'

import { Skeleton } from '@src/quince-components/src'

interface SkeletonPlaceholdersProps {
  length: number
}

export const SkeletonPlaceholders: FC<SkeletonPlaceholdersProps> = ({ length }) => {
  return Array.from({ length }).map((_, index) => <Skeleton key={index} productCardSkeletonWrapper />)
}
